import React from "react";

import images from "../../../utils/images";

export default ({ onInfoClickHandler }) => (
  <div className="CancellationPolicy" onClick={onInfoClickHandler}>
    <span className="CancellationPolicy__title">Cancellation Policy</span>
    <img alt="i" className="CancellationPolicy__image" src={images("./icons/info.png")} />
  </div>
);
